/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable consistent-return */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/no-access-state-in-setstate */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable class-methods-use-this */

import React, { SetStateAction, useCallback, useEffect, useRef, useState } from 'react';
import Draggable from 'react-draggable';
import { CloseOutlined, Code } from '@material-ui/icons';
import { Autocomplete, createFilterOptions } from '@material-ui/lab';
import TextField from '@material-ui/core/TextField';
import { v4 as uuidv4 } from 'uuid';
import logo from './logo_lg.png';
import logoDark from './logo_lg_transparent_black.png';
import logoWhite from './logo_transparent_white.png';
import RcButton from '../UiUtilities/Button';
import { CodeItem, CodeTable, DispositionEvent } from './NewDisposition';

const state = Math.random().toString(36).substring(2);

function Dialer({
  mode,
  handleHoverIn,
  handleHoverOut,
  hover,
  rcAccessToken,
  activeCall,
  setActiveCall,
  setPage,
  selectedDialer,
  setSelectedDialer,
  cxEnabled,
  changeTab,
  setDialer,
  forcedAccountCodes,
  hasForcedAccountCodes,
  idToken,
  setCodeMap,
}: {
  mode: string;
  handleHoverIn: () => any;
  handleHoverOut: () => any;
  hover: boolean;
  cxEnabled: boolean | undefined;
  selectedDialer: string;
  setSelectedDialer: React.Dispatch<SetStateAction<string>>;
  rcAccessToken: string;
  activeCall: any;
  setActiveCall: React.Dispatch<SetStateAction<any>>;
  setPage: React.Dispatch<SetStateAction<string>>;
  changeTab: string;
  setDialer: React.Dispatch<SetStateAction<boolean>>;
  forcedAccountCodes: CodeItem[];
  hasForcedAccountCodes: boolean;
  idToken: string;
  setCodeMap: React.Dispatch<SetStateAction<any>>;
}) {
  const dialerRef = useRef<HTMLIFrameElement>(null);
  const cxDialerRef = useRef<HTMLIFrameElement>(null);
  // Account code overlay state
  const [showAccountCodeOverlay, setShowAccountCodeOverlay] = useState(false);
  const [accountCode, setAccountCode] = useState('');
  const [accountCodeError, setAccountCodeError] = useState<string | null>(null);
  const [accountCodeInput, setAccountCodeInput] = useState('');
  const [callNumber, setCallNumber] = useState('');
  const [skipForcedCode, setSkipForcedCode] = useState(false);
  const [awaitingCall, setAwaitingCall] = useState(false);

  const handleAccountCodeSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const [codeNumber, codeDescription] = accountCodeInput.split(':');
    if (codeNumber && codeDescription) {
      dialerRef.current?.contentWindow?.postMessage(
        {
          type: 'rc-adapter-new-call',
          phoneNumber: callNumber,
          toCall: true,
        },
        '*',
      );
      setAwaitingCall(true);
      setSkipForcedCode(true);
      setShowAccountCodeOverlay(false);
    }
  };

  function onRecievedMessage(event: MessageEvent) {
    if (dialerRef && dialerRef.current) {
      if (event.data && event.data.source !== 'react-devtools-bridge') {
        console.log(event.data);

        if (event.data.type === 'rc-call-init-notify') {
          if (hasForcedAccountCodes && !showAccountCodeOverlay && forcedAccountCodes.length) {
            if (event.data.call.direction === 'Outbound') {
              if (!skipForcedCode) {
                const re = new RegExp('^[0-9]{1,4}$'); // just digits, min 1 max 4
                if (!re.test(event.data.call.to)) {
                  dialerRef.current.contentWindow?.postMessage(
                    {
                      type: 'rc-adapter-control-call',
                      callAction: 'hangup',
                      callId: event.data.call.id,
                    },
                    '*',
                  );
                  setCallNumber(event.data.call.to);
                  setShowAccountCodeOverlay(true);
                  setAccountCodeInput('');
                  setAccountCode('');
                }
              } else {
                setSkipForcedCode(false);
              }
            }
          }
        }
        if (event.data.type === 'rc-login-status-notify') {
          if (event.data.loggedIn === true && event.data.isFreshLogin === false) {
            // console.log("User is already logged in, hiding dialer.");
            setDialer(false); // Hide the dialer
          }
        }
        if (event.data.type === 'rc-call-ring-notify') {
          if (event.data.call.telephonyStatus === 'NoCall') {
            document.title = 'Shadow Agent';
            setActiveCall({
              data: undefined,
              status: undefined,
            });
          }
          if (event.data.call.telephonyStatus !== 'NoCall') {
            document.title = `Incoming Call - ${
              event.data.call.fromUserName || event.data.call.fromNumber || event.data.call.from || ''
            }`;
            setActiveCall({
              data: event.data.call,
              status: 'ringing',
            });
            // Emit event to SAW on ringing events
            if ((window as any)?.chrome && (window as any)?.chrome?.webview) {
              if (event.data.call.direction === 'Outbound') {
                (window as any).chrome.webview.postMessage({ rec: { event: 'CALL_RINGING_OUTBOUND' } });
              } else {
                (window as any).chrome.webview.postMessage({ rec: { event: 'CALL_RINGING' } });
              }
            }
            //  change tab on ringing
            if (changeTab !== 'Disabled') {
              if (changeTab === 'Enabled' || changeTab === event.data.call.direction) {
                setPage('disposition');
              }
            }
          }
        }
        if (event.data.type === 'rc-call-start-notify' || event.data.type === 'rc-call-mute-notify') {
          document.title = `On call - ${
            event.data.call.fromUserName || event.data.call.fromNumber || event.data.call.from || ''
          }`;
          setActiveCall({
            data: event.data.call,
            status: 'active',
          });
        }
        if (event.data.type === 'rc-telephony-session-notify') {
          // Submit forced account code
          if (awaitingCall) {
            setAwaitingCall(false);
            const prefix = 'FPL';
            const [codeNumber, codeDescription] = accountCodeInput.split(':');
            const codeCallId = event.data.telephonySession.id.split('-')[1];
            const message = `${prefix}:${codeCallId}:${codeNumber}:${codeDescription}`;
            const promises = [];

            promises.push(
              fetch(`${process.env.REACT_APP_API_URL}/flash`, {
                method: 'POST',
                body: JSON.stringify({
                  type: 'Forced',
                  message,
                  id: event.data.telephonySession.extensionId,
                  token: rcAccessToken,
                }),
                headers: {
                  authorization: idToken,
                },
              }),
            );

            const eventTime = new Date().toISOString();
            const uuid = uuidv4();

            promises.push(
              fetch(`${process.env.REACT_APP_API_URL}/disposition-codes`, {
                method: 'POST',
                body: JSON.stringify({
                  prefix,
                  codeCallId,
                  codeNumber,
                  codeDescription,
                  accountId: event.data.telephonySession.accountId,
                  extensionId: event.data.telephonySession.extensionId,
                  telephonySessionId: event.data.telephonySession.id,
                  time: eventTime,
                  code: 'Forced',
                  message,
                  id: uuid,
                  address: `${process.env.REACT_APP_API_URL}/site/main-site`,
                }),
                headers: {
                  Authorization: idToken,
                },
              }),
            );

            setCodeMap((oldCodeMap: any) => {
              return oldCodeMap.update(event.data.telephonySession.id, (existing = {} as DispositionEvent) => ({
                id: event.data.telephonySession.id,
                userId: event.data.telephonySession.extensionId,
                date: eventTime,
                duration: 0,
                state: '',
                fromNumber: event.data.telephonySession.from,
                toNumber: event.data.telephonySession.to,
                fromName: event.data.telephonySession.fromName || undefined,
                toName: event.data.telephonySession.toName || undefined,
                internal: false,
                forcedInfo: {
                  code: 'Forced',
                  codeDescription,
                  codeNumber,
                  time: eventTime,
                },

              }));
            });
          }
        }
        if (event.data.type === 'rc-call-end-notify') {
          //  change tab on call end
          if (changeTab !== 'Disabled') {
            if (changeTab === 'Enabled' || changeTab === event.data.call.direction) {
              setPage('disposition');
            }
          }
          document.title = 'Shadow Agent';
          setActiveCall({
            data: undefined,
            status: undefined,
          });
          // Emit event to SAW on call end
          if ((window as any)?.chrome && (window as any)?.chrome?.webview) {
            (window as any).chrome.webview.postMessage({ rec: { event: 'CALL_END' } });
          }
        }
      }
    }
  }

  useEffect(() => {
    if (dialerRef.current) {
      window.addEventListener('message', onRecievedMessage);
    }
    return () => {
      if (dialerRef.current) {
        window.removeEventListener('message', onRecievedMessage);
      }
    };
  }, [dialerRef, onRecievedMessage]);

  useEffect(() => {
    console.log(
      'Forced account codes updated:',
      forcedAccountCodes.map((code) => code.id),
    );
  }, [forcedAccountCodes]);

  useEffect(() => {
    let styleEl: HTMLStyleElement;

    if (mode === 'dark') {
      styleEl = document.createElement('style');
      styleEl.dataset.meta = 'dynamic-dark-mode-styles';
      document.head.appendChild(styleEl);
      const styleSheet = styleEl.sheet;
      if (styleSheet) {
        styleSheet.insertRule(
          `.dark-mode, .mdc-list:not(.sidebar-list) { 
                  background-color: #282828 !important;
                  color: white !important;
              }`,
          0,
        );
        styleSheet.insertRule(
          `.dark-mode-background { 
                  background-color: #282828 !important;
              }`,
          1,
        );
        styleSheet.insertRule(
          `.dark-mode-text, .mdc-notched-outline *, .mdc-radio__background * { 
                  color: white !important;
                  border-color: white !important;
              }`,
          2,
        );
        styleSheet.insertRule(
          `.dark-mode .selected { 
                  background-color: #5d5d5d !important;
              }`,
          3,
        );
        styleSheet.insertRule(
          `#top-bar, .any-top-bar { 
                  background-color: #181818;
              }`,
          4,
        );
        styleSheet.insertRule(
          `#sidebar { 
                  background-color: #181818;
              }`,
          5,
        );
        styleSheet.insertRule(
          `.busy, .available, .invisible { 
                  opacity: 0.7;
              }`,
          6,
        );
        styleSheet.insertRule(
          `.busy-background {
                  background-color: rgba(255, 204, 203, 0.2);
              }`,
          7,
        );
        styleSheet.insertRule(
          `.available-background {
                  background-color: rgba(144, 238, 144, 0.2);
              }`,
          8,
        );
        styleSheet.insertRule(
          `.invisible-background {
                  background-color: rgba(211, 211, 211, 0.2);
              }`,
          9,
        );
        styleSheet.insertRule(
          `.mdc-checkbox * {
                  border-color: white !important;
              }`,
          10,
        );
        styleSheet.insertRule(
          `a.dark-mode, a.dark-mode:active, a.dark-mode:hover {
                  color: white !important;
              }`,
          11,
        );
        styleSheet.insertRule(
          `.icon {
                  z-index: 1;
              }`,
          12,
        );
        styleSheet.insertRule(
          `.button-container { 
              background-color: #262626 !important;
              border: 1px solid #696969 !important;
            }`,
          13,
        );
        styleSheet.insertRule(
          `.selected {
              color: white !important;
              background: #4d4f59 !important;
              box-shadow: inset 1px 1px 9px #0b0b0b44, inset 1px 1px 2px #e4dddd0f !important;
              background-color: #4d4f59 !important;
            }
            `,
          14,
        );
        styleSheet.insertRule(
          `#dialer-container {
              background-color: #272727;
            }
            `,
          15,
        );
        styleSheet.insertRule(
          `.mdc-checkbox *  {
              border-color: #00000000 !important;
            }
            `,
          16,
        );
        styleSheet.insertRule(
          `.cx-label *  {
            color: white !important
            }
            `,
          17,
        );
        styleSheet.insertRule(
          `
            .cxex-wrap {
              background-color: #5d5d5d !important;
              border: 1px solid #696969 !important;
            }
            `,
          18,
        );
        styleSheet.insertRule(
          `
            .cxex-box {
              background-color: #5d5d5d51 !important;
              border: 1px solid #26262600 !important;
              color: white !important;
            }
            `,
          19,
        );
        styleSheet.insertRule(
          `
            .dropdown-button {
              color: white !important;
            }
            `,
          20,
        );
        styleSheet.insertRule(
          `
            .unavailable-dropdown {
              background: #444 !important;
              border: 1px solid #515151 !important;
            }
            `,
          21,
        );
        styleSheet.insertRule(
          `
            .checkmark:checked::before {
              color: rgb(244, 244, 244) !important;
            }
            `,
          22,
        );
        styleSheet.insertRule(
          `
            .cx-toggler-box-left label {
              color: white !important
            }
            `,
          23,
        );
        const iframeEl = document.getElementById('ex-dialer') as HTMLIFrameElement;

        iframeEl?.addEventListener('load', () => {
          if (iframeEl.contentDocument) {
            const iframeDoc = iframeEl.contentDocument;
            const styleEle = iframeDoc.createElement('style');
            styleEle.textContent = `
                .dark-mode { 
                    background-color: #282828 !important; 
                    color: white !important; 
                }
              `;
            iframeDoc.head.appendChild(styleEle);
          }
        });
      }
    }

    return () => {
      // Cleanup: Remove the style element when mode changes to light or component unmounts
      if (styleEl) {
        document.head.removeChild(styleEl);
      }
    };
  }, [mode]);

  return (
    <div style={{ position: 'relative' }}>
      {/* Overlay for account code entry, shown on hover */}
      {/* Fixed Overlay for account code entry */}
      {showAccountCodeOverlay && (
        <div
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            background: 'rgba(0,0,0,0.5)',
            zIndex: 15,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            pointerEvents: 'auto',
          }}
        >
          <form
            onSubmit={handleAccountCodeSubmit}
            style={{
              background: mode === 'light' ? '#fff' : '#222',
              padding: 12,
              borderRadius: 8,
              boxShadow: '0 2px 12px rgba(0,0,0,0.2)',
              width: '95%',
              minHeight: 100,
              display: 'block',
              alignItems: 'center',
              overflow: 'visible', // Allow dropdown to extend outside
            }}
          >
            <label
              htmlFor="account-code-autocomplete"
              style={{ color: mode === 'light' ? '#222' : '#fff', fontWeight: 600, marginBottom: 8 }}
            >
              Enter Account Code
            </label>

            <Autocomplete
              id="account-code-autocomplete"
              blurOnSelect
              disablePortal
              disableClearable
              disableListWrap
              options={forcedAccountCodes.map((code) => code.id)}
              getOptionLabel={(option) => option || ''}
              value={accountCodeInput || undefined}
              onChange={(event, newValue) => {
                setAccountCodeInput(newValue || '');
                setAccountCode(newValue || '');
              }}
              filterOptions={createFilterOptions()}
              ListboxProps={{
                style: {
                  color: mode === 'light' ? 'black' : 'white',
                  background: mode === 'light' ? 'white' : '#444',
                  maxHeight: '200px',
                  overflow: 'auto',
                },
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  size="small"
                  fullWidth
                  style={{ marginBottom: 8 }}
                  InputProps={{
                    ...params.InputProps,
                    style: {
                      color: mode === 'light' ? '#222' : '#fff',
                      backgroundColor: mode === 'light' ? '#fff' : '#333',
                      display: 'flex',
                    },
                  }}
                />
              )}
              style={{
                width: '100%',
                marginBottom: 8,
                position: 'relative',
              }}
            />

            <button
              type="submit"
              style={{
                background: '#0485bf',
                color: '#fff',
                border: 'none',
                borderRadius: 4,
                padding: '6px 18px',
                fontWeight: 600,
                fontSize: 15,
                cursor: 'pointer',
                marginTop: '24px', // Push button to bottom
              }}
              disabled={!!accountCodeError || !accountCodeInput}
            >
              Submit
            </button>
          </form>
        </div>
      )}
      {cxEnabled && (
        <iframe
          title="cx-embeddable"
          id="cx-dialer"
          width="300px"
          height="500px"
          ref={cxDialerRef}
          allow="microphone; autoplay"
          style={{
            paddingTop: hover ? 10 : 0,
            display: selectedDialer === 'cx' ? 'block' : 'none',
          }}
          src="https://ringcentral.github.io/engage-voice-embeddable/app.html"
        />
      )}
      <iframe
        ref={dialerRef}
        id="ex-dialer"
        style={{
          background: mode === 'light' ? 'white' : '#333',
          paddingTop: hover ? 10 : 0,
          display: selectedDialer === 'ex' ? 'block' : 'none',
        }}
        title="ex-embeddable"
        width="300px"
        height="500px"
        allow="microphone; autoplay"
        src={`https://apps.ringcentral.com/integration/ringcentral-embeddable/latest/app.html?clientId=${
          process.env.REACT_APP_RINGCENTRAL_CLIENT_ID as string
        }&state=${state}&disableGlip=false`}
      />
    </div>
  );
}

interface DialerProps {
  mode: 'light' | 'dark';
  dialerMessage: any;
  clientId: string;
  redirectUri: string | undefined;
  dialer: boolean;
  setDialer: React.Dispatch<SetStateAction<boolean>>;
  setSelectedDialer: React.Dispatch<SetStateAction<string>>;
  selectedDialer: string;
  cxEnabled: boolean | undefined;
  rcAccessToken: string;
  setActiveCall: React.Dispatch<SetStateAction<any>>;
  activeCall: any;
  setPage: React.Dispatch<SetStateAction<string>>;
  changeTab: string;
  forcedAccountCodes: CodeTable[];
  hasForcedAccountCodes: boolean;
  idToken: string;
  setCodeMap: React.Dispatch<SetStateAction<any>>;
}

interface DialerState {
  hover: boolean;
  activeDrags: number;
  deltaPosition: { x: number; y: number };
  controlledPosition: { x: number; y: number };
}

class Dialerbox extends React.Component<DialerProps, DialerState> {
  prevWindowHeight = window.innerHeight;

  resizeTimeout: number | null = null;
  isResizing = false;

  constructor(props: DialerProps) {
    super(props);
    this.handleWindowResize = this.handleWindowResize.bind(this);
    const savedPosition = localStorage.getItem('dialer-coordinates');
    const initialPosition = savedPosition ? JSON.parse(savedPosition) : { x: 0, y: 0 };
    this.state = {
      hover: false,
      activeDrags: 0,
      deltaPosition: initialPosition,
      controlledPosition: { x: -400, y: 200 },
    };
  }

  componentDidMount() {
    window.addEventListener('resize', this.handleWindowResize);
    this.handleWindowResize();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleWindowResize);
  }

  // Function to reset the position of the dialer
  resetDialerPosition = () => {
    const dialer = document.getElementById('ex-draggable-dialer');
    const dialerBounds = dialer?.getBoundingClientRect();

    const dialerBottomBuffer = 100;
    const dialerWidthBuffer = 106;
    // Default dialer width and height
    const dialerWidthDefault = 302;

    const dialerWidth = (dialerBounds?.width || dialerWidthDefault) + dialerWidthBuffer;

    const defaultX = window.innerWidth - dialerWidth;
    const defaultY = window.innerHeight - (window.innerHeight - dialerBottomBuffer);

    this.setState({ deltaPosition: { x: defaultX, y: defaultY } });
    localStorage.setItem('dialer-coordinates', JSON.stringify({ x: defaultX, y: defaultY }));
  };

  handleWindowResize = () => {
    const dialer = document.getElementById('ex-draggable-dialer');
    if (!dialer) return;

    // Track Resize
    if (!this.isResizing) {
      this.isResizing = true;
      console.log('Start Resizing');
    }
    // Clear previous timeout
    if (this.resizeTimeout) {
      clearTimeout(this.resizeTimeout);
    }
    // Set new timeout to handle after resize ends
    this.resizeTimeout = window.setTimeout(() => {
      this.isResizing = false;
      console.log('End Resizing');

      const dialerBounds = dialer.getBoundingClientRect();
      // Buffer for dialer
      const dialerRightBuffer = 6;
      const dialerWidthBuffer = 106;
      const dialerTopBuffer = 100;

      const dialerRight = dialerBounds.right + dialerRightBuffer;
      const dialerWidth = dialerBounds.width + dialerWidthBuffer;
      const dialerTop = dialerBounds.top;
      const dialerHeight = dialerBounds.height;
      const dialerBot = dialerBounds.bottom;
      // Get current XY
      let currentX = this.state.deltaPosition.x;
      let currentY = this.state.deltaPosition.y;

      const heightDifference = window.innerHeight - this.prevWindowHeight;

      // Update when window resizes X
      if (dialerRight > window.innerWidth) {
        currentX = window.innerWidth - dialerWidth;
      }

      // Update when window resizes Y
      if (dialerTop <= dialerTopBuffer) {
        // Difference between the previous window.innerheight and current
        currentY -= heightDifference;
      }

      if (window.innerHeight < dialerTopBuffer + dialerHeight) {
        currentY = dialerTopBuffer;
      } else if (dialerBot > window.innerHeight) {
        // If the bottom of the dialer is lower than window, readjust
        currentY -= dialerBot - window.innerHeight;
      }

      // Update only if position changed
      if (currentX !== this.state.deltaPosition.x || currentY !== this.state.deltaPosition.y) {
        this.setState({ deltaPosition: { x: currentX, y: currentY } });
        localStorage.setItem('dialer-coordinates', JSON.stringify({ x: currentX, y: this.state.deltaPosition.y }));
      }

      this.prevWindowHeight = window.innerHeight;
    }, 1000);
  };

  onStart = (e: any) => {
    this.setState({ activeDrags: this.state.activeDrags + 1 });
  };

  onStop = (e: any, position: { x: number; y: number }) => {
    this.setState({
      activeDrags: this.state.activeDrags - 1,
      deltaPosition: { x: position.x, y: position.y },
    });
    localStorage.setItem('dialer-coordinates', JSON.stringify({ x: position.x, y: position.y }));
  };

  handleHoverIn = () => {
    this.setState({ hover: true });
  };

  handleHoverOut = () => {
    this.setState({ hover: false });
  };

  handleClose = () => {
    this.props.setDialer(false);
  };

  handleSelectDialer = (e: any) => {
    e.preventDefault();
    this.props.setSelectedDialer((p) => (p === 'cx' ? 'ex' : 'cx'));
  };

  render() {
    const dragHandlers = { onStart: this.onStart, onStop: this.onStop };
    const { deltaPosition, controlledPosition } = this.state;
    const {
      mode,
      rcAccessToken,
      activeCall,
      setActiveCall,
      setDialer,
      setPage,
      changeTab,
      selectedDialer,
      setSelectedDialer,
      cxEnabled,
      forcedAccountCodes,
      hasForcedAccountCodes,
      idToken,
      setCodeMap,
    } = this.props;
    const { hover } = this.state;

    //   :root {
    //       --text: #bbb;
    //       --bg: #333;
    //   }
    //   div:not(.PresenceStatusIcon_presence, .MuiPopover-root, .RcDatePicker-popover, [aria-hidden]) {
    //       background: var(--bg) !important;
    //       color: var(--text) !important;
    //   }
    //   h1,
    //   h2,
    //   h3,
    //   h4,
    //   h5,
    //   h6,
    //   span:not(.icon) {
    //       color: var(--text) !important;
    //   }
    //   .MuiButtonBase-root:not(:has(> div[type="available"])) path {
    //   fill: var(--text) !important;
    //   }
    //     .MuiTabs-root {
    //       border-bottom: 0px !important;
    //       background: var(--bg) !important;
    //       span {
    //           color: var(--text) !important
    //       }

    //       .RcTab-selected {
    //           span {
    //               color: #00abe5 !important;
    //           }
    //       }
    //   }
    //   .RcIconButton-contained::before {
    //       border: 1px solid rgb(104 105 111) !important
    //   }
    //   [data-sign='navigationBar'] {
    //       div {
    //           border-radius: 0px !important
    //       }
    //       background-color: transparent !important;
    //       box-shadow: 0px 0px 0px #000000 !important;
    //   }
    // `);

    return (
      <Draggable
        bounds="#root"
        handle=".draggable-handle"
        cancel=".draggable-handle-right"
        defaultPosition={deltaPosition}
        position={deltaPosition}
        scale={1}
        {...dragHandlers}
      >
        <div
          onMouseEnter={this.handleHoverIn}
          onMouseLeave={this.handleHoverOut}
          id="ex-draggable-dialer"
          className={`draggable-container ${mode === 'light' ? 'light' : 'dark'} ${hover ? 'hover' : ''}`}
          style={{
            position: 'fixed',
            marginTop: 100,
            bottom: 100,
            left: 100,
            zIndex: 8111111199000,
            opacity: hover ? 1 : 0.95,
          }}
        >
          <div
            className={`draggable-handle ${hover ? 'hover' : ''} ${mode === 'light' ? 'light' : 'dark'}`}
            style={{ display: 'flex', alignItems: 'center' }}
          >
            <span
              className="dragging-handle"
              style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
            >
              <div
                className="dragging-handle-left"
                style={{
                  width: cxEnabled ? 179 : 249,
                  background: mode === 'light' ? '#e9eff3' : '#545452',
                  borderRadius: 5,
                  display: 'flex',
                  justifyContent: 'start',
                  alignItems: 'center',
                  height: 19,
                  border: mode === 'light' ? '1px solid #dfdfdf' : 0,
                  marginRight: cxEnabled ? 0 : 10,
                }}
              >
                <img
                  className="dialer-logo"
                  draggable="false"
                  src={mode === 'light' ? logoDark : logoWhite}
                  alt="logo"
                />
                <span className="notranslate">Shadow Agent</span>
              </div>
              <div className="draggable-handle-right" style={{ cursor: 'default' }}>
                {cxEnabled && (
                  <button
                    type="button"
                    className={`notranslate draggable-dialer-toggle ${mode}`}
                    onClick={(e) => this.handleSelectDialer(e)}
                  >
                    {selectedDialer === 'ex' ? 'EX' : 'CX'}
                  </button>
                )}
                <RcButton
                  className="draggable-exit-button"
                  onClick={() => setDialer(false)}
                  color="white"
                  style={{
                    borderRadius: 50,
                    maxHeight: 18,
                    minHeight: 18,
                    minWidth: 18,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    maxWidth: 18,
                  }}
                  size="xs"
                  bg="rgb(211, 43, 46)"
                >
                  <CloseOutlined fontSize="small" style={{ width: 10, height: 10 }} />
                </RcButton>
              </div>
            </span>
          </div>
          <Dialer
            setDialer={setDialer}
            setPage={setPage}
            changeTab={changeTab}
            selectedDialer={selectedDialer}
            setSelectedDialer={setSelectedDialer}
            cxEnabled={cxEnabled}
            handleHoverIn={this.handleHoverIn}
            handleHoverOut={this.handleHoverOut}
            mode={mode}
            hover={hover}
            //  styleSheet={styleSheet}
            rcAccessToken={rcAccessToken}
            activeCall={activeCall}
            setActiveCall={setActiveCall}
            forcedAccountCodes={forcedAccountCodes && forcedAccountCodes.length ? forcedAccountCodes[0].items : []}
            hasForcedAccountCodes={hasForcedAccountCodes}
            idToken={idToken}
            setCodeMap={setCodeMap}
          />
        </div>
      </Draggable>
    );
  }
}

export default Dialerbox;
